export default __webpack_public_path__ + "static/media/194.b78666f0.jpg";